var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDialogX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    rx: 5,
    fill: "#F4F4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.374,
    y: 8.88867,
    width: 1,
    height: 12,
    transform: "rotate(45 17.374 8.88867)",
    fill: "#09041C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.082,
    y: 17.375,
    width: 1,
    height: 12,
    transform: "rotate(135 18.082 17.375)",
    fill: "#09041C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDialogX);
export default __webpack_public_path__ + "static/media/close-dialog-x.cf37a35d5fb7f57e065888a2f11c8822.svg";
export { ForwardRef as ReactComponent };